// Theme constants for consistent styling across the application

export const GRADIENTS = {
  primary: 'linear(to-r, blue.400, purple.500, pink.500)',
  primaryHover: 'linear(to-r, blue.500, purple.600, pink.600)',
  primaryActive: 'linear(to-r, blue.600, purple.700, pink.700)',
};

export const COLORS = {
  accent: '#C7F64A',
  accentHover: '#B8E63C',
  background: {
    light: 'gray.50',
    white: 'white',
    dark: 'gray.900',
    darker: 'gray.950',
  },
  text: {
    primary: 'gray.900',
    secondary: 'gray.700',
    tertiary: 'gray.600',
    light: 'gray.500',
    lighter: 'gray.400',
    lightest: 'gray.300',
  },
  border: {
    light: 'gray.200',
    medium: 'gray.300',
    dark: 'gray.800',
  },
};

export const SPACING = {
  header: {
    height: '64px',
    padding: { base: 4, md: 8, lg: 12 },
  },
  input: {
    height: '44px',
    heightSm: '38px',
  },
  button: {
    height: '44px',
    heightSm: '38px',
    heightXs: '32px',
  },
  container: {
    py: { base: 12, md: 16 },
    pyCompact: { base: 8, md: 12 },
  },
};

export const TYPOGRAPHY = {
  fontSize: {
    xs: '12px',
    sm: '13px',
    md: '14px',
    lg: '15px',
  },
  fontWeight: {
    normal: '400',
    medium: '500',
    semibold: '600',
    bold: '700',
    extrabold: '800',
  },
};

export const ANIMATIONS = {
  transition: 'all 0.2s',
  transitionSlow: 'all 0.3s ease',
};

export const Z_INDEX = {
  header: 1000,
  drawer: 1300,
  modal: 1400,
  tooltip: 1500,
};
